export const DEFAULT_EMBED_SURVEY_SETUPS = {
  styleType: '',
  isShowLabel: false,
  isDisplayColor: false,
  choiceOrder: false,
  ratingIconSize: 'medium',
}

const NON_STYLE_SETUP_KEYS = ['isShowLabel', 'isDisplayColor', 'choiceOrder', 'ratingIconSize']

export function isEmbedSetupsDirty(currentSetups, savedSetups, savedStyleType) {
  if (currentSetups.styleType !== savedStyleType) {
    return true
  }
  return NON_STYLE_SETUP_KEYS.some(
    (key) =>
      String(currentSetups[key] ?? DEFAULT_EMBED_SURVEY_SETUPS[key]) !==
      String(savedSetups[key] ?? DEFAULT_EMBED_SURVEY_SETUPS[key])
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/EmbedSurveyV2/utils.js